import * as React from 'react';
import { createViewConfig, view, assignProps } from '@sail/engine';
import { useCurrentLayer } from './layers/Layer';
import { useUiConfig } from '../providers/UiConfigProvider';
import { useMediaQuery } from '../providers/UiMediaQueryProvider';
const isNestedOverlay = (layerContext)=>{
    if (!layerContext) {
        return false;
    }
    if (layerContext.type === 'overlay') {
        return true;
    }
    return isNestedOverlay(layerContext.parent);
};
export const BackdropConfig = createViewConfig({
    props: {},
    name: 'Backdrop',
    flattens: true
});
function useBackdropOpacity(layerContext) {
    const uiConfig = useUiConfig();
    const { isTouch, isSmallScreen } = useMediaQuery();
    const isUsingBottomSheets = isTouch && isSmallScreen && (uiConfig === null || uiConfig === void 0 ? void 0 : uiConfig.enableBottomSheets);
    // For bottom sheets, always use full opacity
    if (isUsingBottomSheets) {
        return 1;
    }
    // For stacked Drawers, set opacity to 0 when in a nested layer
    if (isNestedOverlay(layerContext === null || layerContext === void 0 ? void 0 : layerContext.parent)) {
        return 0;
    }
    // By default, the opacity is undefined (will be set by parent component)
    return undefined;
}
export const Backdrop = BackdropConfig.createView(({ onClose, onPress, ...props })=>{
    const layerContext = useCurrentLayer();
    const ref = React.useRef(null);
    const opacity = useBackdropOpacity(layerContext);
    const mountTimeRef = React.useRef(0);
    React.useEffect(()=>{
        mountTimeRef.current = Date.now();
    }, []);
    return /*#__PURE__*/ React.createElement(view.div, {
        "data-testid": "backdrop",
        ref: ref,
        uses: [
            assignProps({
                onClick: (event)=>{
                    const elapsedTime = Date.now() - mountTimeRef.current;
                    // Do not close the backdrop if the user clicks on a child element or if the backdrop has been mounted for less than 100ms
                    if (event.target === event.currentTarget && (process.env.NODE_ENV === 'test' || process.env.NODE_ENV !== 'test' && elapsedTime > 100)) {
                        var _this;
                        (_this = onClose !== null && onClose !== void 0 ? onClose : onPress) === null || _this === void 0 ? void 0 : _this();
                    }
                }
            })
        ],
        css: {
            opacity,
            // Backdrop in touch devices should never be scrollable, we set `touch-action: none` to prevent tap+drag in the Backdrop to scroll the document's body in iOS.
            // This has no effect when enableBottomSheeets is true, since we already have a mechanism in RootLayer to lock body scroll in iOS. Setting touch-action here
            // still prevents issues when `enableBottomSheets` is not enabled, the deprecated RootLayer is used, or the components are rendered within iframes (Connect).
            // For safety, we only set touch-action to none when the Backdrop has no children, since it is not scrollable in that case, and there are a few cases where
            // the Backdrop is used as a wrapper for other components.
            touchAction: props.children ? 'unset' : 'none'
        },
        ...props
    });
}, {
    css: {
        backgroundColor: 'backdrop',
        position: 'fixed',
        top: 'space.0',
        left: 'space.0',
        right: 'space.0',
        bottom: 'space.0'
    }
});

//# sourceMappingURL=Backdrop.js.map